<template>
  <form @submit.prevent="handleSubmitForm">
    <div class="row">
      <div class="col-12">
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label for="participants">Participants</label>
              <input
                type="text"
                v-model.trim="participants.name"
                id="participants"
                placeholder="Name"
                class="form-control"
                :class="{
                  'is-invalid': errors.name
                }"
                name="name"
                data-vv-as="name"
                v-validate="'required|regex:^[A-Za-z\\s\\d-\.]*$'"
              />
              <div v-if="veeErrors.first('name')" class="invalid-feedback">
                {{ veeErrors.first("name") }}
              </div>
            </div>
            <div class="form-group">
              <input
                type="text"
                v-model.trim="participants.email"
                placeholder="Email"
                class="form-control"
                :class="{
                  'is-invalid': errors.email
                }"
                name="email"
                data-vv-as="email"
                v-validate="
                  'required|email|uniqueEmail|regex:^([A-Za-z\\d]+[-_\.]?)+@([^\\s@])+\.([^\\s@])+$'
                "
              />
              <div v-if="veeErrors.first('email')" class="invalid-feedback">
                {{ veeErrors.first("email") }}
              </div>
            </div>
            <div class="form-group">
              <input
                type="text"
                v-model.trim="participants.company"
                placeholder="Company"
                class="form-control"
                :class="{
                  'is-invalid': !!errors.company
                }"
                name="company"
                data-vv-as="company"
                v-validate="'required'"
              />
              <div v-if="veeErrors.first('company')" class="invalid-feedback">
                {{ veeErrors.first("company") }}
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="form-group text-right mb-0">
              <ActionButton
                label="Add"
                :theme="{ primary, secondary, event, danger }"
                style="width: auto; margin-left: auto; margin-bottom: 0;margin-top: 10px;"
                type="submit"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import axios from "@/helpers/axios";
import { Validator } from "vee-validate";

const ActionButton = () => import("@/components/ActionButton");

export default {
  name: "AddEventParticipant",
  components: {
    ActionButton
  },
  props: {
    singleEventId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      eventId: this.singleEventId,
      activePallete: {
        pale: "#E1FAF4",
        main: "#51B67E",
        event: "#00BC8A"
      },
      errorPallete: {
        main: "#dc3545",
        event: "#c82333"
      },
      validEmail: true,
      participants: {
        name: null,
        email: null,
        company: null
      },
      errors: {
        name: null,
        email: null,
        company: null
      },
      addedParticipants: [],
      selectedParticipant: null
    };
  },
  mounted() {
    const isUniqueEmailAsync = email =>
      axios
        .get(`/events/${this.eventId}/meta?value=${this.participants.email}`)
        .then(res => {
          if (!res.data.data.length) return { valid: true };
          return {
            valid: false,
            data: { message: `${email} is already taken.` }
          };
        });

    Validator.extend("uniqueEmail", {
      validate: isUniqueEmailAsync,
      getMessage: (field, params, data) => data.message
    });
  },
  methods: {
    handleAddparticipantClick() {
      if (this.selectedParticipant !== null) {
        this.addedParticipants.push(this.selectedParticipant);
        this.participants.find((e, i) => {
          if (e === this.selectedParticipant) {
            this.participants.splice(i, 1);
          }
        });
        this.selectedParticipant = null;
      }
    },
    handleparticipantRemoveClick(params) {
      const { index } = params;
      this.addedParticipants.find((e, i) => {
        if (index === i) {
          this.participants.push(e);
          this.addedParticipants.splice(i, 1);
        }
      });
    },
    async handleSubmitForm() {
      let meta_particpants = [
        {
          key: "participants",
          label: "Participants",
          value: JSON.stringify(this.participants),
          eventId: this.eventId,
          createdAt: new Date(),
          updatedAt: new Date()
        }
      ];
      try {
        let errorPass = await this.$validator.validateAll();
        if (!errorPass) {
          throw {
            type: "warning",
            title: "Warning",
            error: new Error("Please fix the error fields")
          };
        }
        if (this.participants.email) {
          if (
            !this.participants.email.includes("@") ||
            !this.participants.email.includes(".com")
          ) {
            errorPass = false;
            this.errors.email = true;
            this.validEmail = false;
          }
        }
        let result = {};
        if (errorPass) {
          result = await this.$store.dispatch("addEventMeta", meta_particpants);
          if (result.status == 200) {
            this.$toastr.success("Added a New Participant", "Success");
          }

          await this.$store.dispatch("fetchEvents");
          this.$emit("close");
        }
      } catch (error) {
        const errType = error.type || "error";
        const errTitle = error.title || "Error";
        const errMsg = error.error.message || error.message;

        this.$toastr[errType](errMsg, errTitle);
      }
    }
  },
  computed: {
    primary() {
      return this.$store.state.app.scheme.primary;
    },
    secondary() {
      return this.$store.state.app.scheme.secondary;
    },
    event() {
      return this.$store.state.app.scheme.event;
    },
    danger() {
      return this.$store.state.app.scheme.danger;
    }
  }
};
</script>

<style lang="scss" scoped>
.form-group {
  .input-wrapper {
    button {
      margin-left: 15px;
    }
  }
  label {
    font-weight: 500;
    font-size: $font-size-xs;
  }
  input {
    border-radius: 5px;
    color: $gray-800;
    font-family: "Gotham Book", sans-serif;
    font-size: $font-size-xs;
  }
  ul {
    font-size: $font-size-xs;
  }
}
</style>
